import React from 'react';
import Datetime from 'react-datetime';
import moment from 'moment';
import { ShowIf, validatable } from 'components/utils';

const dateFormat = 'DD/MM/YYYY'

class DatePicker extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isValid: true,
      value: this.props.value,
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      message: ''
    }
  }

  onChange(e) {
    let inputDate = e;
    if (e._d) {
      inputDate = e._d;
    }

    this.state.value = inputDate
    this.setState({
      ...this.state
    });
    this.validate();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.startDate != this.state.startDate) {
      this.setState({
        startDate: nextProps.startDate
      });
    }

    if (nextProps.endDate != this.state.endDate) {
      this.setState({
        endDate: nextProps.endDate
      });
    }

    if (nextProps.value != this.props.value) {
      this.setState({
        value: nextProps.value
      });
    }

    if(!this.state.isValid && nextProps.require && !nextProps.value) {
      this.setState({
        isValid: false,
        message: this.props.requireMessage
      });
    } else if (nextProps.value && !moment(nextProps.value, dateFormat).isValid()) {
      this.setState({
        isValid: false,
        message: this.props.errMessage
      });
    } else if((!nextProps.require && moment(nextProps.value, dateFormat).isValid()) || (nextProps.require && nextProps.value && moment(nextProps.value, dateFormat).isValid())) {
      this.setState({
        isValid: true
      });
    }
  }

  classNames() {
    if (this.state.isValid) {
      return 'calendar_icon';
    } else {
      return 'calendar_icon pt-datepicker-danger';
    }
  }

  clearValue() {
    this.state.value = '';
    this.setState({
      ...this.state
    })
    this.props.onChange(this.state.value);
  }

  validate() {
    if(this.props.value != this.state.value) {
      this.props.onChange(this.state.value);
    }
    let isValid = (typeof this.state.value == 'string' && this.state.value.trim() == '') || moment(this.state.value, dateFormat).isValid();

    this.setState(
      {
        isValid
      }
    );

    if(this.props.require && (typeof this.state.value == 'string' && this.state.value.trim() == '')) {
      this.setState(
        {
          // TODO: Need to check if date string is valid, eg: '20/07/32ab'
          isValid: false,
          message: this.props.requireMessage
        }
      );
      this.DatetimePicker.focus();
      return false;
    } else if (!isValid) {
      this.setState(
        {
          // TODO: Need to check if date string is valid, eg: '20/07/32ab'
          isValid: false,
          message: this.props.errMessage
        }
      );
      this.DatetimePicker.focus();
      return false;
    } else {
      return true;
    }
  }

  render() {
    return (
      <div className={this.props.className}>
        <div className="input-datepicker">
          <Datetime className={ this.classNames() } onChange={ this.onChange.bind(this) } dateFormat={ this.props.dateFormat } timeFormat={ this.props.timeFormat } value={ this.state.value }
            closeOnSelect={true} inputProps={{disabled: true}} onBlur={ this.validate.bind(this) } inputProps={ { placeholder: this.props.placeholder, maxLength: this.props.maxLength, name: this.props.name } } />
        </div>
        <ShowIf condition={this.props.require == true}>
          <input className='hidden-input' ref={(DatetimePicker) => {this.DatetimePicker = DatetimePicker}}/>
        </ShowIf>
        <ShowIf condition={!this.state.isValid}>
          <div className="pt-form-helper-text">
            { this.state.message }
          </div>
        </ShowIf>
      </div>
    )
  }
}


DatePicker.defaultProps = {
  className: 'input-group',
  label: '',
  timeFormat: 'HH:mm',
  dateFormat: 'DD/MM/YYYY',
  placeholder: 'DD/MM/YYYY',
  maxLength: 20,
  value: '',
  require: false,
  errMessage: 'Sai định dạng',
  requireMessage: 'Đây là trường bắt buộc, vui lòng không để trống',
  onChange: function() {
    console.log('Please assign onChange method')
  },
  startDate: '',
  endDate: '',
  name:''
}

export default validatable(DatePicker);



// WEBPACK FOOTER //
// ./components/danangtrade-forms/common/DatePicker.jsx